<template>
  <div class="courses-single-content">
    <template v-if="quizInfo">
      <!-- Congratulations Message for Topic Quiz Completion -->
      <div
        v-if="quizInfo.quiz.takers.score != null && quizInfo.quiz.takers.completed"
        class="quiz-success-message"
        style="
          background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
          border-radius: 12px;
          padding: 30px;
          margin-bottom: 25px;
          color: white;
          text-align: center;
        "
      >
        <div style="font-size: 40px; margin-bottom: 15px">✅</div>
        <h3
          style="
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
            color: white;
          "
        >
          {{ $t("congratulations") }}
        </h3>
        <p style="font-size: 16px; color: white; opacity: 0.95">
          {{ $t("passed_test") }}
        </p>
      </div>

      <div
        class="courses-single-title courses-title-frame courses-lesson-title"
      >
        <i class="fa-title"></i>
        <h2>{{ quizInfo.quiz.title }}</h2>
      </div>
      <p
        class="courses-lesson-title"
        style="width: 500px; margin: 0 auto; text-align: center"
        v-if="quizInfo.quiz.takers.score != null && quizInfo.quiz.takers.completed"
        v-cyr2lat="$store.getters.lang"
      >
        {{ $t("intermediate_test_passed", { course: quizInfo.quiz.title }) }}
      </p>

      <div
        class="courses-test-btn"
        v-if="quizInfo.quiz.takers.score != null && quizInfo.quiz.takers.completed"
      >
        <p class="courses-test-arrow">
          <b style="font-size: 22px; color: #33ec72">{{
            quizInfo.quiz.takers.score
          }}</b>
          / 100
        </p>
        <a href="#!" class="courses-test-reply success" @click.prevent
          >{{ $t("passed_test") }}
        </a>
        <a
          href="#!"
          class="courses-test-arrow"
          v-show="isLast"
          @click.prevent="nextFinish($route.query.id)"
          ><span v-if="isLast">{{ $t("to_final_test") }}</span>
          <i v-if="isLast" class="fa-arrow-line"></i
        ></a>
        <a
          href="#!"
          class="courses-test-arrow"
          v-show="!isLast"
          @click.prevent="nextLesson($route.params.slug)"
          ><span v-if="!isLast">{{ $t("next_lesson") }}</span>
          <i v-if="!isLast" class="fa-arrow-line"></i
        ></a>
      </div>
      <div
        class="courses-test-btn"
        v-else-if="
          quizInfo.quiz.takers.score != null && !quizInfo.quiz.takers.completed
        "
      >
        <p class="courses-test-arrow">
          <b style="font-size: 22px; color: tomato"
            >{{ quizInfo.quiz.takers.score }}
          </b>
          / 100
        </p>
        <router-link
          :to="`/test/${$route.params.slug}`"
          class="courses-test-reply"
          style="width: 280px"
          >{{ $t("retake_test") }} <i class="fa-arrow-line"></i
        ></router-link>
        <a href="#!" class="courses-test-arrow">
          {{ quizInfo.quiz.takers.chances_left }} /
          {{ quizInfo.quiz.chances }}</a
        >
      </div>
      <div class="courses-home-bar" v-else>
        <router-link
          :to="`/test/${$route.params.slug}`"
          class="courses-test-start"
          ><i class="fa-play"></i> {{ $t("start_test") }}</router-link
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLast: false,
      loading: false,
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch("getQuizBySlug", this.$route.params.slug);
      await this.$store.dispatch("getCourse", this.$route.query.id);
    } catch (e) {
      this.$store.commit("setNotification", "no-quiz");
    }
    this.isLastQuiz(this.$route.params.slug);
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      await this.$store.dispatch("getQuizBySlug", to.params.slug);
      await this.$store.dispatch("getCourse", to.query.id);
    } catch (e) {
      this.$store.commit("setNotification", "no-quiz");
    }
    this.isLastQuiz(to.params.slug);
    next();
  },
  methods: {
    async nextLesson(slug) {
      let nextId = null;
      const material = this.course?.material;
      if (material) {
        const topicIndex = material.findIndex(
          (topic) => topic.quiz && topic.quiz.slug === slug
        );
        if (topicIndex !== -1 && material[topicIndex + 1]?.lessons?.length) {
          nextId = material[topicIndex + 1].lessons[0].id;
        }
      }
      if (nextId) {
        await this.$router.push(`/lessons/${nextId}?id=${this.$route.query.id}`);
      }
    },
    isLastQuiz(slug) {
      const material = this.course?.material;
      if (!material || !material.length) return;
      const lastTopic = material[material.length - 1];
      this.isLast = !!(lastTopic && lastTopic.quiz && lastTopic.quiz.slug === slug);
    },
    nextFinish(id) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (this.course?.final_quiz?.slug) {
        this.$router.push(`/final-quiz/${this.course.final_quiz.slug}?id=${id}`);
      }
    },
  },
  computed: {
    quizInfo() {
      return this.$store.getters.getQuizInfo;
    },
    course() {
      return this.$store.getters.getCourse;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
